<template>
  <div class="extra_info_area">
    <md-card v-if="activeSection === 'IF Industry Financials Balance Sheet'">
      <md-card-header
        ><md-icon>account_balance</md-icon>Assets Liabilities</md-card-header
      >
      <md-card-content>
        <!-- <h4>Praesent venenatis</h4> -->
        <p>
          {{ BSText.assetsLiabilities }}
        </p>
      </md-card-content>
    </md-card>
    <md-card v-if="activeSection === 'IF Industry Financials Balance Sheet'">
      <md-card-header
        ><md-icon>vertical_split</md-icon>Net Fixed Assets</md-card-header
      >
      <md-card-content>
        <p>
          {{ BSText.netFixedAssets }}
        </p>
      </md-card-content>
    </md-card>
    <md-card v-if="activeSection === 'IF Industry Financials Balance Sheet'">
      <md-card-header><md-icon>article</md-icon>Debt Equity</md-card-header>
      <md-card-content>
        <p>
          {{ BSText.debtEquity }}
        </p>
      </md-card-content>
    </md-card>
    <md-card v-if="activeSection === 'IF Financial Ratios Cash Flow-Solvency'">
      <md-card-header><md-icon>article</md-icon>Current Ratio</md-card-header>
      <md-card-content>
        <p>
          {{ BSText.currentRatio2 }}
        </p>
        <p>
          {{ BSText.currentRatio1 }}
        </p>
      </md-card-content>
    </md-card>
    <md-card v-if="activeSection === 'IF Industry Financials Income Statement'">
      <md-card-header
        ><md-icon>article</md-icon>Industry Revenues</md-card-header
      >
      <md-card-content>
        <p>
          {{ PLText.IR }}
        </p>
      </md-card-content>
    </md-card>
    <md-card v-if="activeSection === 'IF Industry Financials Income Statement'">
      <md-card-header><md-icon>article</md-icon>Cost of Goods</md-card-header>
      <md-card-content>
        <p>
          {{ PLText.COGS }}
        </p>
      </md-card-content>
    </md-card>
    <md-card v-if="activeSection === 'IF Industry Financials Income Statement'">
      <md-card-header
        ><md-icon>article</md-icon>Operating Expenses</md-card-header
      >
      <md-card-content>
        <p>
          {{ PLText.OE }}
        </p>
      </md-card-content>
    </md-card>
    <md-card v-if="activeSection === 'IF Industry Financials Income Statement'">
      <md-card-header
        ><md-icon>article</md-icon>Discretionary Owner Earnings</md-card-header
      >
      <md-card-content>
        <p>
          {{ PLText.DOE }}
        </p>
      </md-card-content>
    </md-card>
    <md-card
      v-if="activeSection === 'IF Industry Financials Sources & Uses Of Funds'"
    >
      <md-card-header><md-icon>article</md-icon>Cash Balances</md-card-header>
      <md-card-content>
        <p>
          {{ SUText.top_paragraph }}
        </p>
      </md-card-content>
    </md-card>
    <md-card
      v-if="
        activeSection === 'IF Industry Financials Sources & Uses Of Funds' &&
          SUText.contributer_1
      "
    >
      <md-card-header><md-icon>article</md-icon>Cash Balances</md-card-header>
      <md-card-content>
        <p>
          {{ SUText.contributer_1 }}
        </p>
      </md-card-content>
    </md-card>
    <md-card
      v-if="
        activeSection === 'IF Industry Financials Sources & Uses Of Funds' &&
          SUText.contributer_2
      "
    >
      <md-card-header><md-icon>article</md-icon>Cash Balances</md-card-header>
      <md-card-content>
        <p>
          {{ SUText.contributer_2 }}
        </p>
      </md-card-content>
    </md-card>
    <md-card
      v-if="
        activeSection === 'IF Industry Financials Sources & Uses Of Funds' &&
          SUText.contributer_3
      "
    >
      <md-card-header><md-icon>article</md-icon>Cash Balances</md-card-header>
      <md-card-content>
        <p>
          {{ SUText.contributer_3 }}
        </p>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';

export default {
  components: {},
  mixins: [formatData],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      profile: (state) => state.user.report,
      activeSection: (state) => state.user?.activeSection,
      narrativeText: (state) => state.user?.report?.narrativeText,
      BSText: (state) => state.user?.report?.narrativeText?.BS,
      PLText: (state) => state.user?.report?.narrativeText?.PL,
      SCText: (state) => state.user?.report?.narrativeText?.SC,
      SUText: (state) => state.user?.report?.narrativeText?.SU,
    }),
  },
};
</script>
